import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setChooseMode, setDataChooseMode } from "../store/siteSlice";
import { ENUM_MODE_GAME } from "../store/enums";
import { setModeGame } from "../store/commonSlice";
import { checkGameIsLive } from "../utils/utilsLiveGame";
import useLoginAction from "./useLoginAction";

export default function useChooseMode() {
  const dispatch = useDispatch();
  const mode = useSelector((state) => state.common.modeGame);
  const hardModeGame = useSelector((state) => state.common.hardModeGame);
  const { onLoginAction } = useLoginAction();

  const onChoseMode = useCallback(
    ({ cbReal = () => {}, cbDemo = () => {}, close = () => {}, game }) => {
      const isLiveDemo = checkGameIsLive(game);
      const hardRealGame = isLiveDemo;
      if (hardRealGame) {
        onLoginAction(() => {
          cbReal();
          dispatch(setModeGame(ENUM_MODE_GAME.real));
        });
        return;
      }

      if (hardModeGame) {
        return hardModeGame === ENUM_MODE_GAME.demo ? cbDemo() : cbReal();
      }
      dispatch(setChooseMode(true));
      dispatch(setDataChooseMode({ cbReal, cbDemo, close, game }));
    },
    [hardModeGame]
  );

  const checkIsModeGame = useCallback(
    (...props) => {
      if (mode) return true;
      onChoseMode(...props);
    },
    [mode, onChoseMode]
  );

  return { checkIsModeGame, onChoseMode };
}
